import qs from '../../scripts/util/DOM/qs';
import hogan from 'hogan.js';
import addClass from '../../scripts/util/DOM/addClass';
import {map} from 'ramda';
import isElement from '../../scripts/util/isElement';
import {renderTab, clearPrevs, setDefaultTab} from '../tab/tab';
import _ from '../../../node_modules/lodash/lodash.js';
import $ from 'jquery';

const selectors = {
	block: '#support__search-block',
	content: '.support__content',
	input: '.search__input',
	support: '.support',
	card: '.support__search-info-card',
	search: '.support__search',
	resultsNotFound: '.support__results',
	cross: '.search__button_cross',
	tabMenu: '.support__search-tab-menu',
	tabItemCount: '.tab__item-count',
	defaultSection: 'section[data-category="all"]',
	preloader: '.support__preloader'
};

const classes = {
	search: 'support_search',
	searchActive: 'search_active',
	searchItem: '.search',
	animate: 'support_search_animate',
	animateContent: 'support__content_animate',
	showContent: 'support__content_show',
	showCard: 'support__search-info-card_show',
	showMain: 'support_show-main',
	resultBlockShow: 'support__results-show',
	tabDisabled: 'tab__item_disabled',
	tabMenuShow: 'support__search-tab-menu-show',
	tabMenuAnimate: 'support__search-tab-menu-animate',
	preloaderHide: 'support__preloader-hide'
};

let template = '';

let xhr = null;

if (isElement('.support')) {
	const html = qs(selectors.block);
	template = hogan.compile(html.innerHTML);
}

const renderTemplate = item => {
	const data = {
		title: item.title,
		id: item.id
	};
	return template.render(data);
};

const getCards = data => {
	const templates = map(renderTemplate, data);

	const newTemplates = templates;
	let insertedItems = 0;
	templates.forEach(function (item, index) {
		const newIndex = index + 1;
		if (newIndex % 3 === 1) {
			newTemplates.splice(index + insertedItems, 0, '<div class=\'support__search-info-card-wrap\'>');
			insertedItems++;

		} else if (newIndex % 3 === 0)
		{
			newTemplates.splice(newIndex + insertedItems, 0, '</div>');
			insertedItems++;
		}
	});
	return templates;
};

const clearSupport = () => {
	const support = qs(selectors.support);
	support.classList.remove(classes.search);
	support.classList.remove(classes.animate);
	support.classList.remove(classes.showMain);
};


const showPreloader = () => {
	$(selectors.preloader).removeClass(classes.preloaderHide);
};

const hidePreloader = () => {
	$(selectors.preloader).addClass(classes.preloaderHide);
};

const notFoundShow = () => {
	$(selectors.resultsNotFound).addClass(classes.resultBlockShow);
	hidePreloader();
};

const notFoundHide = () => {
	$(selectors.resultsNotFound).removeClass(classes.resultBlockShow);
	showPreloader();
};

const hideCards = () => {
	$(selectors.card).removeClass(classes.showCard);
};

const showCards = () => {
	$(selectors.card).addClass(classes.showCard);
};

const showTabMenu = () => {
	$(selectors.tabMenu).addClass(classes.tabMenuAnimate).addClass(classes.tabMenuShow);
};

const hideTabMenu = () => {
	$(selectors.tabMenu).removeClass(classes.tabMenuAnimate).removeClass(classes.tabMenuShow);
};

const showDefaultSection = () => {
	notFoundHide();
	$(selectors.defaultSection).addClass(classes.animateContent).addClass(classes.showContent);
	showTabMenu();
	hidePreloader();
	showCards();
};

const hideDefaultSection = () => {
	$(selectors.defaultSection).removeClass(classes.animateContent).removeClass(classes.showContent);
	hideTabMenu();
	showPreloader();
};

const hideSearch = () => {
	notFoundHide();
	const support = qs(selectors.support);
	addClass(classes.showMain)(support);
	$(classes.searchItem).removeClass(classes.searchActive);
	$(selectors.support).removeClass(classes.search).removeClass(classes.animate);
	clearSupport();
	$(selectors.input).val('');
};

const showSearch = () => {
	$(selectors.support).addClass(classes.animate).addClass(classes.search);
};

const insertCard = (data, container) => {
	const categoryId = $(container).data('category');
	const tabItem = $('.tab__item[data-item-category=' + categoryId + ']');

	if (data.length > 0) {
		container[0].innerHTML = getCards(data).join(' ');
		data.forEach(function (item, i) {
			const textBlock = $(container).find('.info-card__text')[i];
			textBlock.innerHTML = item.body;
		});
		$(tabItem).removeClass(classes.tabDisabled);
	} else {
		tabItem.addClass(classes.tabDisabled);
	}

	tabItem.find(selectors.tabItemCount).html('(' + data.length + ')');
};

const getDataFromSearch = searchString => {
	let loadingFlag = false;
	if (loadingFlag !== true) {
		if (xhr !== null) {
			xhr.abort();
		}
		xhr = $.ajax({
			url: '/zendesk-search-articles',
			type: 'POST',
			data: {search: searchString, _csrf: $('meta[name="csrf-token"]').prop('content')},
			dataType: 'json',
			cache: false,
			success: result => {
				if (result.error) {
					loadingFlag = false;
				}
				else {
					result = JSON.parse(result);
					const data = result.results;
					if (data.length < 1) {
						hideDefaultSection();
						notFoundShow();
					} else {
						data.forEach(function (item, i) {
							let newstr = item.body.replace(/<\/?[^>]+>/g, '');
							newstr = newstr.replace(/\s+/g, ' ');
							newstr = newstr.substr(0, 170);
							const index = newstr.lastIndexOf(' ');
							newstr = newstr.substr(0, index);
							const condition = newstr.endsWith('.') || newstr.endsWith(':') || newstr.endsWith(';') || newstr.endsWith(',') || newstr.endsWith('/');
							if (condition) {
								newstr = newstr.substr(0, newstr.length - 1);
							}
							newstr += '...';
							data[i].body = newstr;
						});

						const containers = qs(selectors.search).querySelectorAll(selectors.content);
						containers.forEach(function (item) {
							const category = $(item).data('category');
							const container = $(item);
							let filteredData;
							if (category === 'all') {
								filteredData = data;
							} else {
								filteredData = _.filter(data, {category_id: category});
							}
							insertCard(filteredData, container);
						});
						showDefaultSection();
					}
					loadingFlag = false;
				}
			}
		});
	}
};

const inputHandler = () => {
	hideDefaultSection();
	hideTabMenu();
	clearPrevs();
	setDefaultTab();
	hideCards();
	notFoundHide();
	showSearch();
	setTimeout(function () {
		let searchString = $(selectors.input).val();
		searchString = searchString.replace(/^\s+/, '');
		if (searchString.length > 0) {
			$('.search').addClass(classes.searchActive);
			getDataFromSearch(searchString);
		} else {
			hideSearch();
		}
	}, 500);
};

const render = () => {
	renderTab();
	$(selectors.input).on('input', inputHandler);
	$(selectors.cross).on('click', hideSearch);
};

export default render;
